import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthService} from '../services/auth.service';
import {HttpStatus} from '../constants/HttpStatus';
import {Router} from '@angular/router';
import {NotifierService} from '../services/notifier.service';

@Injectable({providedIn: 'root'})
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,
              private notifierService: NotifierService,
              private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(response => {
      if (response.error && response.error.message && response.error.message.type && response.error.message.text) {
        this.notifierService.notify(response.error.message.type, response.error.message.text);
      }
      if (response.status === HttpStatus.TOO_MANY_REQUESTS) {
        this.router.navigate(['/too-many-requests']);
      }
      if (response.status === HttpStatus.UNAUTHORIZED) {
        if (this.authService.auth()) {
          this.authService.clear();
        }
        this.router.navigate(['/']);
      }

      if (response.status === HttpStatus.FORBIDDEN) {
        this.router.navigate(['/']);
      }
      const error = response instanceof HttpErrorResponse ? (response.error ? (response.error.text ? response.error.text : response.error) : response.statusText) : response;
      return throwError(error);
    }));
  }
}
